import { TENANT_ROSTER_FORMAT, TENANT_TYPES } from '@/utils/constants';
import { checkCDNUrl, isEmptyValue } from '@/utils/utils';

export class AdminUtilsSerializer {

    private static INSTANCE = new AdminUtilsSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeOAthClientSecret(payload: any) {
        const clientSecret = payload || {};
        return clientSecret;
    }

    public normalizeGetOAthClientSecret(payload: any) {
        const clientSecret = payload || [];
        return clientSecret;
    }

    public tenantListSerializer(payload: any) {
        const tenantList = payload || {};
        for (const iterator of tenantList.list) {
            iterator.displayParnterType = iterator.tenant_type && TENANT_TYPES[iterator.tenant_type] ?
                TENANT_TYPES[iterator.tenant_type] : iterator.tenant_type;
            iterator.displayRosterFormat = iterator.roster_format && TENANT_ROSTER_FORMAT[iterator.roster_format] ?
                TENANT_ROSTER_FORMAT[iterator.roster_format] : iterator.roster_format;
            iterator.image_url = checkCDNUrl(iterator.image_url);
            const admin = !isEmptyValue(iterator.count) &&
                !isEmptyValue(iterator.count.admin) ? iterator.count.admin : 0;
            const student = !isEmptyValue(iterator.count) &&
                !isEmptyValue(iterator.count.student) ? iterator.count.student : 0;
            const teacher = !isEmptyValue(iterator.count) &&
                !isEmptyValue(iterator.count.teacher) ? iterator.count.teacher : 0;
            iterator.totalUsers = admin + student + teacher;
            iterator.isActive = iterator.status === 'active' ? true : false;
        }
        return tenantList;
    }
}

export const adminUtilsSerializer = AdminUtilsSerializer.instance;
